function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M2.024 30.452h5.119V54H2.024z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 30.452h19.452M10.214 44.786s3.265-2.046 5.096-2.048c1.84-.002 3.288 2.055 5.13 2.048 1.806-.007 3.212-2.04 5.019-2.048 1.84-.007 3.288 2.041 5.13 2.048 1.875.007 3.364-2.048 5.24-2.048 1.875 0 3.364 2.065 5.24 2.048 1.79-.017 3.174-2.028 4.963-2.048 1.893-.02 5.296 2.048 5.296 2.048M10.214 48.881s3.265-2.046 5.096-2.048c1.84-.002 3.288 2.055 5.13 2.048 1.806-.007 3.212-2.04 5.019-2.048 1.84-.007 3.288 2.041 5.13 2.048 1.875.007 3.364-2.048 5.24-2.048 1.875 0 3.364 2.065 5.24 2.048 1.79-.017 3.174-2.028 4.963-2.048 1.893-.02 5.296 2.048 5.296 2.048M10.214 52.976s3.265-2.046 5.096-2.048c1.84-.002 3.288 2.055 5.13 2.048 1.806-.007 3.212-2.04 5.019-2.048 1.84-.007 3.288 2.041 5.13 2.048 1.875.007 3.364-2.048 5.24-2.048 1.875 0 3.364 2.065 5.24 2.048 1.79-.017 3.174-2.028 4.963-2.048 1.893-.02 5.296 2.048 5.296 2.048"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.429 7.929l-3.071 7.166 4.095 4.095-3.072 9.215 3.072 2.047-1.024-3.071 4.095-8.19-4.095-4.096 2.048-5.119L24.548 11h5.119l-5.119-1.024-5.119-2.047",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.476,
  cy: 4.557,
  r: 2.323,
  strokeLinecap: "square"
}));

var SvgDiveboard = function SvgDiveboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiveboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dive board.31e01a47.svg";
export { ForwardRef as ReactComponent };